exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reference[data-v-a5bdf268]{margin-bottom:0}.reference[data-v-a5bdf268],.reference.active[data-v-a5bdf268]{transition:margin-bottom .2s ease}.reference.active[data-v-a5bdf268]{margin-bottom:5px}.properties[data-v-a5bdf268]{max-height:400px;overflow-y:auto}.hidden[data-v-a5bdf268],.properties[data-v-a5bdf268]{transition:max-height .2s ease}.hidden[data-v-a5bdf268]{max-height:0;overflow:hidden}", ""]);

// exports
